import { useEffect } from 'react';

/**
 * Hook to hide the page loader on component mount
 * This is necessary for client-side navigation with React Router
 * since the loader scripts only run on initial page load
 */
export const usePageLoader = () => {
  useEffect(() => {
    // Hide loader after a short delay to allow page to render
    const timer = setTimeout(() => {
      const loaderWrap = document.querySelector('.loader-wrap') as HTMLElement;
      if (loaderWrap) {
        loaderWrap.style.opacity = '0';
        loaderWrap.style.pointerEvents = 'none';

        // Remove from DOM after animation completes
        setTimeout(() => {
          if (loaderWrap.parentNode) {
            loaderWrap.style.display = 'none';
          }
        }, 500);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);
};
